import { useParams, Navigate, Link, useSearchParams } from "react-router-dom";
import { stories } from "../../data/stories.data";
import SectionWrapper from "../ui/SectionWrapper";

export default function SuccessStoryDetail() {
  const { slug } = useParams();
  const story = stories.find((s) => s.slug === slug);
  const [searchParams] = useSearchParams()

  const origin = searchParams.get('origin')

  if (!story) {
    return <Navigate to="/success-stories" replace />;
  }

  return (
    <SectionWrapper>
        <section className="w-full relative overflow-hidden  rounded-b-lg bg-[#F2F4F7]">
      {/* Background accent */}


      <div className="relative z-10 mx-auto max-w-3xl  px-6">


        {/* Header */}
        <header className="mt-8 text-center">
          <span className="inline-block text-xs font-medium text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
            {story.category}
          </span>

          <h1 className="mt-4 text-3xl font-bold text-gray-900">
            {story.title}
          </h1>


        </header>

        {/* Image */}
        <div className="mt-14 overflow-hidden rounded-2xl shadow-sm">
         <img
            src={`${story.image}-800.jpg`}
            srcSet={`${story.image}-480.jpg 480w, ${story.image}-800.jpg 800w`}
            sizes="(max-width: 768px) 100vw, 256px"
            alt={story.title}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover"
            />
        </div>

        {/* Content */}
        <div
        className="mt-4 text-sm text-gray-600 prose prose-sm max-w-4xl space-y-4 py-4 mx-auto"
        dangerouslySetInnerHTML={{ __html: story.content }}
        />

      </div>
      <div className="mt-12">
        {story.logo && (
          <div className="absolute -bottom-0 -right-0 w-32 opacity-70 p-2">
            <img src={story.logo} alt={`${story.title} logo`} className="w-full h-auto object-contain" />
          </div>
        )}
      </div>
    </section>
    </SectionWrapper>
  );
}
